import { Link } from 'react-router-dom';
import DeliveryPartners from './DeliveryPartners';

const HOW_IT_WORKS = [
  {
    icon: 'fa-seedling',
    title: 'تأمین',
    description:
      'خرید مستقیم از کشاورزان، کارخانه‌ها',
    color: '#10b981',
  },
  {
    icon: 'fa-warehouse',
    title: 'انبار',
    description:
      'مدیریت هوشمند موجودی در انبارهای سراسر کشور',
    color: '#6366f1',
  },
  {
    icon: 'fa-truck',
    title: 'توزیع',
    description:
      'بهینه‌سازی مسیر با الگوریتم‌های پیشرفته لجستیک',
    color: '#f59e0b',
  },
  {
    icon: 'fa-store',
    title: 'فروش',
    description:
      'عرضه مستقیم به مشتریان از طریق ایران چارسوق آنلاین',
    color: '#ef4444',
  },
];

const FEATURES = [
  {
    icon: 'fa-balance-scale',
    title: 'حسابداری دوطرفه',
    description:
      'تمام تراکنش‌های مالی با استاندارد دفتر کل دوطرفه ثبت می‌شوند — غیرقابل تغییر و کاملاً قابل ممیزی.',
  },
  {
    icon: 'fa-hand-holding-usd',
    title: 'وام BNPL',
    description:
      'مشتریان می‌توانند با استفاده از سرمایه سرمایه‌گذاران، خرید اقساطی بدون بهره انجام دهند.',
  },
  {
    icon: 'fa-ticket-alt',
    title: 'کوپن یارانه',
    description:
      'یکپارچه‌سازی با سامانه کالابرگ دولتی برای حمایت از اقشار کم‌درآمد',
  },
  {
    icon: 'fa-route',
    title: 'بهینه‌سازی لجستیک',
    description:
      'الگوریتم‌های Knapsack و TSP برای مسیریابی هوشمند و کاهش هزینه حمل.',
  },
  {
    icon: 'fa-shield-alt',
    title: 'احراز هویت امن',
    description:
      'ورود با OAuth2 و JWT — توکن‌ها در کوکی‌های HttpOnly ذخیره می‌شوند.',
  },
  {
    icon: 'fa-chart-line',
    title: 'سرمایه‌گذاری',
    description:
      'سرمایه‌گذاران می‌توانند مستقیماً در زنجیره تأمین سرمایه‌گذاری کنند و بازدهی بگیرند.',
  },
];

const PARTICIPANTS = [
  {
    role: '🚜 کشاورزان',
    description: 'تأمین‌کننده محصولات کشاورزی',
  },
  {
    role: '🏭 کارخانه‌ها',
    description: 'تولید و فرآوری کالا',
  },
  {
    role: '🛒 مشتریان',
    description: 'خرید از ایران چارسوق آنلاین',
  },
  {
    role: '💰 سرمایه‌گذاران',
    description: 'تأمین مالی زنجیره تأمین',
  },
  {
    role: '🏛 مدیران',
    description: 'نظارت و مدیریت سکو',
  },
];

const TECHNOLOGIES = [
  'FastAPI',
  'PostgreSQL',
  'Redis',
  'React',
  'Docker',
  'Celery',
  'SQLAlchemy',
  'Pydantic',
  'Nginx',
];

export default function AboutUs() {
  return (
    <div
      className="container about-us-page"
      style={{
        paddingTop: '2rem',
        maxWidth: '900px',
        margin: '0 auto',
      }}
    >
      {/* Hero */}
      <section
        style={{
          textAlign: 'center',
          marginBottom: '2.5rem',
        }}
      >
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: 800,
            marginBottom: '0.5rem',
          }}
        >
          درباره{' '}
          <span style={{ color: '#6366f1' }}>
            ایران چارسوق
          </span>
        </h1>

        <p
          style={{
            color: '#6b7280',
            fontSize: '1.05rem',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: 1.8,
          }}
        >
          سکوی یکپارچه تجارت الکترونیک و زنجیره تأمین —
          از مزرعه و کارخانه تا درب منزل مشتری
        </p>
      </section>

            {/* Meaning of the name */}
      <section
        className="card"
        style={{
          padding: '1.75rem',
          marginBottom: '1.5rem',
        }}
      >
        <h2 className="about-section-title">
          <i
            className="fas fa-map-signs"
            style={{ color: '#10b981' }}
          />
          «چارسوق» یعنی چه؟
        </h2>

        <div
          className="about-work-grid"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.75rem',
            flexWrap: 'wrap',
            margin: '0 0 1.25rem',
            fontSize: '1.05rem',
            fontWeight: 700,
          }}
        >
          <span style={{ padding: '0.4rem 1rem', background: '#f9fafb', borderRadius: '10px' }}>
            چهار
          </span>
          <span style={{ color: '#6b7280' }}>+</span>
          <span style={{ padding: '0.4rem 1rem', background: '#f9fafb', borderRadius: '10px' }}>
            سو
          </span>
          <span style={{ color: '#6b7280' }}>=</span>
          <span
            style={{
              padding: '0.4rem 1rem',
              background: '#10b9811a',
              color: '#047857',
              borderRadius: '10px',
            }}
          >
            چهارسوق / چارسوق
          </span>
        </div>

        <p className="about-section-text">
          «چارسوق» که به شکل «چهارسوق» و «چارسو» نیز نوشته می‌شود، از دو بخش
          «چهار» و «سو» ساخته شده است؛ یعنی جایی که چهار راه یا چهار سمت به
          هم می‌رسند. در بازارهای سنتی ایران، چهارسوق محل تلاقی دو گذر اصلی
          بازار بود که اغلب سقفی گنبدی داشت و پررفت‌وآمدترین نقطه بازار به
          شمار می‌رفت.
        </p>

        <p className="about-section-text">
          در چهارسوق، تاجر و صنعتگر و مشتری به هم می‌رسیدند و کالا از چهار
          سوی شهر در یک نقطه گرد هم می‌آمد. به همین دلیل، این نام در فرهنگ
          ایرانی نماد قلب تجارت و پیوند مردم و بازار است.
        </p>

        <p className="about-section-text">
          ما این نام را برگزیدیم چون <strong>ایران چارسوق</strong> همین نقش
          را در قالبی نو بر عهده دارد: نقطه‌ای که کشاورز، کارخانه، انبار،
          حمل‌ونقل و مشتری در آن به هم می‌رسند و کالای اساسی بدون واسطه‌های
          غیرضروری از تولیدکننده به خانه‌ها می‌رسد.
        </p>
      </section>

      {/* Mission */}
      <section
        className="card"
        style={{
          padding: '1.75rem',
          marginBottom: '1.5rem',
        }}
      >
        <h2 className="about-section-title">
          <i
            className="fas fa-bullseye"
            style={{ color: '#ef4444' }}
          />
          مأموریت ما
        </h2>

        <p className="about-section-text">
          ایران چارسوق با هدف{' '}
          <strong>
            شفاف‌سازی و بهینه‌سازی زنجیره تأمین کالای اساسی در ایران
          </strong>{' '}
          ایجاد شده است. ما با اتصال مستقیم کشاورزان،
          کارخانه‌ها، گمرکات، انبارها، رانندگان و مشتریان،
          واسطه‌های غیرضروری را حذف کرده و هزینه‌های لجستیک
          را کاهش می‌دهیم. هدف نهایی ما{' '}
          <strong>
            دسترسی عادلانه همه مردم ایران به کالاهای اساسی
            با قیمت مناسب
          </strong>{' '}
          است.
        </p>
      </section>

      {/* How It Works */}
      <section
        className="card"
        style={{
          padding: '1.75rem',
          marginBottom: '1.5rem',
        }}
      >
        <h2 className="about-section-title">
          <i
            className="fas fa-cogs"
            style={{ color: '#6366f1' }}
          />
          چارسوق چطور کار می‌کند؟
        </h2>

        <div
          className="about-feature-grid"
          style={{
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
          }}
        >
          {HOW_IT_WORKS.map((step) => (
            <div
              key={step.title}
              style={{
                textAlign: 'center',
                padding: '1rem',
                background: '#f9fafb',
                borderRadius: '12px',
              }}
            >
              <div
                className="about-participants-grid"
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: `${step.color}18`,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '0.5rem',
                }}
              >
                <i
                  className={`fas ${step.icon}`}
                  style={{
                    color: step.color,
                    fontSize: '1.2rem',
                  }}
                />
              </div>

              <h4
                style={{
                  fontSize: '0.95rem',
                  marginBottom: '0.3rem',
                }}
              >
                {step.title}
              </h4>

              <p
                style={{
                  fontSize: '0.8rem',
                  color: '#6b7280',
                  lineHeight: 1.7,
                }}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <DeliveryPartners />

      {/* Key Features */}
      <section
        className="card"
        style={{
          padding: '1.75rem',
          marginBottom: '1.5rem',
        }}
      >
        <h2 className="about-section-title">
          <i
            className="fas fa-star"
            style={{ color: '#f59e0b' }}
          />
          ویژگی‌های کلیدی
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '0.75rem',
          }}
        >
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              style={{
                display: 'flex',
                gap: '0.6rem',
                alignItems: 'flex-start',
                fontSize: '0.9rem',
              }}
            >
              <i
                className={`fas ${feature.icon}`}
                style={{
                  color: '#6366f1',
                  marginTop: '0.2rem',
                  fontSize: '0.85rem',
                  flexShrink: 0,
                }}
              />

              <div>
                <strong>{feature.title}</strong>

                <p
                  style={{
                    color: '#6b7280',
                    fontSize: '0.8rem',
                    marginTop: '0.15rem',
                    lineHeight: 1.7,
                  }}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Participants */}
      <section
        className="card"
        style={{
          padding: '1.75rem',
          marginBottom: '1.5rem',
        }}
      >
        <h2 className="about-section-title">
          <i
            className="fas fa-users"
            style={{ color: '#8b5cf6' }}
          />
          مشارکت‌کنندگان چارسوق
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '0.75rem',
          }}
        >
          {PARTICIPANTS.map((participant) => (
            <div
              key={participant.role}
              style={{
                padding: '0.75rem',
                background: '#f9fafb',
                borderRadius: '10px',
                textAlign: 'center',
              }}
            >
              <p
                style={{
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  marginBottom: '0.2rem',
                }}
              >
                {participant.role}
              </p>

              <p
                style={{
                  color: '#6b7280',
                  fontSize: '0.75rem',
                }}
              >
                {participant.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section
        style={{
          textAlign: 'center',
          padding: '2rem 0',
        }}
      >
        <p
          style={{
            color: '#6b7280',
            marginBottom: '1rem',
          }}
        >
          آماده‌اید به چارسوق بپیوندید؟
        </p>

        <div
          style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to="/products"
            className="btn btn-primary"
          >
            مشاهده محصولات
          </Link>

          <Link
            to="/signup"
            className="btn btn-outline"
          >
            ثبت‌نام کنید
          </Link>
        </div>
      </section>
    </div>
  );
}
